




















import Vue from "@/shim-vue";
import {
    Component,
    Prop,
    VModel,
    Watch
} from "vue-property-decorator";

import config from "@/config/switch";

@Component({
    name: "LoniSwitch"
})
export default class LoniSwitch extends Vue {
    @VModel({ type: Boolean, required: true })
    private active!: boolean;

    @Prop()
    public size?: string;

    @Prop()
    public activeColor?: string;

    @Prop()
    public inactiveColor?: string;

    @Prop({ type: Boolean, default: false })
    public disabled!: boolean;

    @Prop({ type: Boolean, default: false })
    public loading!: boolean;

    @Prop({ type: Boolean, default: false })
    public async!: boolean;

    private isLoading = false;

    public get options() {
        return {
            size: this.size ?? config.size,
            activeColor: this.activeColor ?? config.activeColor,
            inactiveColor: this.inactiveColor ?? config.inactiveColor
        }
    }

    @Watch("loading")
    private onLoadingChanged() {
        this.isLoading = this.loading;
    }

    created() {
        this.isLoading = this.loading;
    }

    private change() {
        this.$emit("click");
        if(this.disabled || this.isLoading) {
            return;
        }
        if(this.async) {
            this.isLoading = true;
        }
        if(this.async) {
            this.$emit("change", (status: boolean) => {
                this.isLoading = false;
                if(status) {
                    this.active = !this.active;
                }
            });
        } else {
            this.active = !this.active;
            this.$emit("change", this.active);
        }
    }
}
